import { LabelWithDescription } from "../../../common/LabelWithDescription";
import { Checkbox as CheckboxComponent } from "../../../ui/checkbox";
import { Label } from "../../../ui/label";
import { cn } from "../../../utils";
import { CheckboxProps } from "../types";

export const Checkbox = ({
  disabled,
  error,
  name = "checkbox",
  checked,
  onCheckedChange,
  label,
  description,
  labelWrapperClassName,
  labelClassName,
  descriptionClassName,
  checkboxClassName,
  wrapperClassName,
}: React.PropsWithChildren<CheckboxProps>) => {
  return (
    <Label
      htmlFor={name}
      className={cn(
        "group/checkbox-item flex items-start p-4 rounded-lg gap-2 transition-all duration-200",
        "font-normal text-purple-muted-200 leading-5",
        {
          "cursor-pointer": !disabled,
          "cursor-not-allowed": disabled,
          "border border-destructive": error,
        },
        wrapperClassName,
      )}
    >
      <CheckboxComponent
        id={name}
        disabled={disabled || error}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={cn("mt-0.5", checkboxClassName)}
      />
      <LabelWithDescription
        label={label}
        description={description}
        disabled={disabled}
        labelClassName={labelClassName}
        descriptionClassName={descriptionClassName}
        labelWrapperClassName={labelWrapperClassName}
      />
    </Label>
  );
};

Checkbox.displayName = "CheckboxGroupItemComponent";
